import React from "react";
import { Snackbar, Alert } from "@mui/material";

const NotificationSnackbar = ({ snackbar, setSnackbar }) => {
  const handleClose = () => setSnackbar((prev) => ({ ...prev, open: false }));

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      onClose={handleClose}
    >
      <Alert
        severity={snackbar.severity}
        sx={{ width: "100%" }}
        onClose={handleClose}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationSnackbar;
